/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-04 02:10:01
 *
 *******************************************************/
// @flow

/**
 * Check if is freemium plan
 *
 * @param  {string} selectedPlan   selected plan
 * @return {boolean}
 */
export function isFreemiumPlan(tenantApp: Object) {
  const { selectedPlan = '' } = tenantApp;

  return selectedPlan.includes('freemium');
}

/**
 * Get percent
 * @param {*} current 
 * @param {*} total 
 * @returns 
 */
export function displayPercentage(current, total) {
  let percentage = (current / total) * 100;
  let formattedPercentage;

  if (Number.isInteger(percentage)) {
    formattedPercentage = percentage + '%';
  } else {
    formattedPercentage = percentage.toFixed(2);
    formattedPercentage = parseFloat(formattedPercentage).toString() + '%';
  }
  return formattedPercentage;
}